var _defs, _rect, _rect2, _circle, _circle2, _path, _text, _text2, _rect3, _text3, _rect4, _circle3, _path2, _text4, _text5, _rect5, _circle4, _path3, _text6, _text7, _rect6, _circle5, _path4, _text8, _text9, _circle6, _path5, _circle7, _circle8, _path6, _rect7, _text0;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFleetcoreVerifiedDriverOnboardingEvidenceInterface(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 720,
    height: 420,
    viewBox: "0 0 720 420",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "FleetCore verified driver onboarding interface") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "fcdriScore",
    x1: 500,
    y1: 76,
    x2: 650,
    y2: 255
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#087CFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF2775"
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 718,
    height: 418,
    rx: 28,
    fill: "#FFFFFF",
    stroke: "#C8D9ED",
    strokeWidth: 2
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 24,
    y: 22,
    width: 672,
    height: 58,
    rx: 16,
    fill: "#F4F8FD"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 51,
    r: 17,
    fill: "#E9F4FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 53,
    cy: 45,
    r: 6,
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 64c1-8 4-12 11-12s10 4 11 12",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 48,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 15,
    fontWeight: 820
  }, "Driver evidence profile")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 82,
    y: 66,
    fill: "#677B95",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Evidence captured before the first shift")), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 561,
    y: 36,
    width: 110,
    height: 30,
    rx: 15,
    fill: "#EAF4FF"
  })), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 616,
    y: 55,
    textAnchor: "middle",
    fill: "#087CFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5,
    fontWeight: 800
  }, "READY TO REVIEW")), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 112,
    width: 390,
    height: 70,
    rx: 15,
    fill: "#F9FBFE",
    stroke: "#087CFF",
    strokeOpacity: 0.3
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 147,
    r: 13,
    fill: "#EAF4FF",
    stroke: "#087CFF",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m53 147 4 4 8-9",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 143,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 810
  }, "IDENTITY EVIDENCE")), _text5 || (_text5 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 162,
    fill: "#687C96",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Facial match supported")), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 198,
    width: 390,
    height: 70,
    rx: 15,
    fill: "#F9FBFE",
    stroke: "#FF2775",
    strokeOpacity: 0.3
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 233,
    r: 13,
    fill: "#FFF0F6",
    stroke: "#FF2775",
    strokeWidth: 1.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m53 233 4 4 8-9",
    fill: "none",
    stroke: "#FF2775",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text6 || (_text6 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 229,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 810
  }, "DRIVER LICENCE")), _text7 || (_text7 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 248,
    fill: "#687C96",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Details captured")), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 284,
    width: 390,
    height: 70,
    rx: 15,
    fill: "#F9FBFE",
    stroke: "#087CFF",
    strokeOpacity: 0.3
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 59,
    cy: 319,
    r: 13,
    fill: "#EAF4FF",
    stroke: "#087CFF",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m53 319 4 4 8-9",
    fill: "none",
    stroke: "#087CFF",
    strokeWidth: 2,
    strokeLinecap: "round"
  })), _text8 || (_text8 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 315,
    fill: "#07152A",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 12.5,
    fontWeight: 810
  }, "WORK PERMIT")), _text9 || (_text9 = /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 334,
    fill: "#687C96",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 10.5
  }, "Requirement recorded")), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 563,
    cy: 210,
    r: 88,
    fill: "#020716",
    stroke: "url(#fcdriScore)",
    strokeWidth: 6
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M563 159c-18 0-32 14-32 32m0 58c3-25 14-37 32-37s29 12 32 37",
    fill: "none",
    stroke: "#80C4FF",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 563,
    cy: 188,
    r: 20,
    fill: "none",
    stroke: "#80C4FF",
    strokeWidth: 4
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 617,
    cy: 158,
    r: 17,
    fill: "#FF2775"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m609 158 6 6 11-13",
    fill: "none",
    stroke: "#FFFFFF",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 470,
    y: 322,
    width: 186,
    height: 44,
    rx: 12,
    fill: "#07152A"
  })), _text0 || (_text0 = /*#__PURE__*/React.createElement("text", {
    x: 563,
    y: 349,
    textAnchor: "middle",
    fill: "#FFFFFF",
    fontFamily: "Inter, Arial, sans-serif",
    fontSize: 11.5,
    fontWeight: 780
  }, "HUMAN REVIEW REMAINS REQUIRED")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFleetcoreVerifiedDriverOnboardingEvidenceInterface);
export default __webpack_public_path__ + "static/media/fleetcore-verified-driver-onboarding-evidence-interface.d53e011f0c307e4567cf5e464d5be890.svg";
export { ForwardRef as ReactComponent };